import { useInitialBreakpoint } from '@jetshop/core/components/BreakpointProvider';
import { useShopConfig } from '@jetshop/core/hooks/useShopConfig';
import React from 'react';
import Media from 'react-media';
import { getMaxBreakpointValue } from './utils/breakpoints';
export const Above = ({ breakpoint, render, children }) => {
    const { theme: { breakpoints } } = useShopConfig();
    const { breakpointIndex } = useInitialBreakpoint();
    const query = { minWidth: breakpoints[breakpoint] };
    return (React.createElement(Media, { query: query, defaultMatches: Object.keys(breakpoints).indexOf(breakpoint) <= breakpointIndex }, children || render));
};
export function Below({ breakpoint, render, children }) {
    const { theme: { breakpoints } } = useShopConfig();
    const { breakpointIndex } = useInitialBreakpoint();
    const bpMap = Object.entries(breakpoints).map(([key, val]) => {
        return { label: key, size: val };
    });
    const query = { maxWidth: getMaxBreakpointValue(breakpoint, bpMap) };
    return (React.createElement(Media, { query: query, defaultMatches: Object.keys(breakpoints).indexOf(breakpoint) > breakpointIndex }, children || render));
}
export function Between({ children, render, breakpoints }) {
    const { theme: { breakpoints: configuredBreakpoints } } = useShopConfig();
    const { breakpointIndex } = useInitialBreakpoint();
    const bpMap = Object.entries(configuredBreakpoints).map(([key, val]) => {
        return { label: key, size: val };
    });
    const labels = Object.keys(configuredBreakpoints);
    const defaultMatches = labels.indexOf(breakpoints[0]) <= breakpointIndex &&
        labels.indexOf(breakpoints[1]) >= breakpointIndex;
    const query = {
        minWidth: configuredBreakpoints[breakpoints[0]],
        maxWidth: getMaxBreakpointValue(breakpoints[1], bpMap)
    };
    return (React.createElement(Media, { query: query, defaultMatches: defaultMatches }, children || render));
}
export function Only() { }
//# sourceMappingURL=Breakpoints.js.map